import { upperCase } from 'lodash'

import { createDateFromString } from 'utils/date'
import { get } from 'utils/lodash'
import { formatCentsToDollars, formatDecimalCentsToDollars } from 'utils/price'

export const getTransformDisposalTicket = ticket => {
  const effectiveDate = get(ticket, 'effectiveDate')
  return {
    workOrderId: get(ticket, 'workOrderId'),
    effectiveDate: effectiveDate ? createDateFromString(effectiveDate) : null,
    taxable: get(ticket, 'taxable', false),
    disposalTicketId: get(ticket, 'id'),
    ticketNumber: get(ticket, 'ticketNumber', ''),
    disposalSiteId: get(ticket, 'disposalSiteId', ''),

    materials: get(ticket, 'materials', []).map(material => ({
      id: get(material, 'id'),
      disposalSiteMaterialId: get(material, 'disposalSiteMaterial.id'),
      unitOfMeasure: upperCase(get(material, 'unitOfMeasure') || get(material, 'disposalSiteMaterial.measureUnit', '')),
      quantity: get(material, 'quantity'),
      unitPriceDollars: formatCentsToDollars(get(material, 'unitPriceCents')),
      feeMaterialId: get(material, 'feeMaterialId', ''),
      useDisposalFeeRate: !get(material, 'useSiteRate', true),
      rate: formatDecimalCentsToDollars(get(material, 'rate')),
      includedTonnage: get(material, 'includedTonnage', 0),
      useMinimumCharge: get(material, 'useMinimumCharge', false),
      minimumCharge: formatCentsToDollars(get(material, 'minimumChargeCents')),
      overageWeight: get(material, 'overageWeight', 0),
      overageFee: formatCentsToDollars(get(material, 'overageFeeCents')),
    })),
  }
}

// Legacy "first ticket" shape for callers that pass the whole array (billing cell, V1 form, popover).
// Multi-ticket callers transform each ticket directly via getTransformDisposalTicket.
export const getTransformDisposalData = tickets => getTransformDisposalTicket(get(tickets, '[0]'))

export const isFormInValid = state => {
  const hasEmptyMaterial = get(state, 'materials', []).find(material => !material.disposalSiteMaterialId)
  return !get(state, 'ticketNumber') || !get(state, 'disposalSiteId') || hasEmptyMaterial
}

export const getIsTaxableFromLocalStorage = () => {
  return localStorage.getItem('isDisposalFeeTaxable') === 'true'
}

export const setIsTaxableInLocalStorage = value => {
  localStorage.setItem('isDisposalFeeTaxable', value)
}
